import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AppSettings } from '../config/app-settings';

export interface NotificationItem {
  id: number;
  title: string;
  type: 'initiative' | 'task';
  due_date: string;
  days_remaining: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private http = inject(HttpClient);
  
  notifications = signal<NotificationItem[]>([]);
  unreadCount = signal<number>(0);

  getUpcoming(): Observable<NotificationItem[]> {
    return this.http.get<NotificationItem[]>(AppSettings.NOTIFICATIONS).pipe(
      tap(items => {
        this.notifications.set(items);
        this.unreadCount.set(items.length);
      })
    );
  }
}
